import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

import { styled } from '@mui/material/styles';
const headCells = [


  
  { id: 'bn_title', numeric: false, label: 'Title' },
  { id: 'bn_image', numeric: false, label: 'Banner' },
  
   { id: '',  label: '' },
  ]
  
  
  const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});


  function stableSort(array, cmp) {
	  const stabilizedThis = array.map((el, index) => [el, index]);
	  stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	  });
	  return stabilizedThis.map(el => el[0]);
}
function desc(a, b, orderBy) {
	  if (b[orderBy] < a[orderBy]) {
		return -1;
	  }
	  if (b[orderBy] > a[orderBy]) {
		return 1;
	  }
	  return 0;
}
function getSorting(order, orderBy) {
	return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  };

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};


const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});


export default class Banner extends Component {
	
    constructor(props) {
    super(props);
   
      this.state = {redirect: false,Bannerdata:[],bn_title:'',bn_title:'',

     bnid:'',page: 0 ,prevpage:0,totaldata:0,rowsPerPage:50,rowsPaging:[],
	 
	  order:'desc' ,orderBy:'',bn_id:'',
	          
      }
       this.updateDonenewParent = this.updateDonenewParent;
	   
	}
	
	updateDonenewParent = (text) => { this.apicall(this.state.page,this.state.rowsPerPage); }
	
	Search(){
	this.setState({  
      page: 0,
      rowsPerPage:50,
	  prevpage:0,Branchdata:[]
    });
	

}
	



	componentDidMount() {
		document.title = "AthaYog Living - Banner";
	
	if(localStorage.getItem("AYLuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Default'
          })
		  }
	
	

  this.apicall(this.state.page,this.state.rowsPerPage);
  
} 




handleClickSearch=()=>{   
 
  
  this.apicall(this.state.page,this.state.rowsPerPage); 

	
} 

myChangeHandler = (event) => {
	
	 const re = /^[0-9]+$/;
  let nam = event.target.name;
  let val = event.target.value;

  this.setState({[nam]: val});
  
}

apicall(page,rowsPerPage){
	 
	 axios.get(Serverurl+'ajaxbanner.php?action=getall&bn_title='+this.state.bn_title+'&StartIndex='+page+'&PageSize='+rowsPerPage)
	 //axios.get(Serverurl+'ajaxbanner.php?action=getall&StartIndex='+page+'&PageSize='+rowsPerPage)
     
	
  .then(resp => {  
		
    if(resp.data.length>0){
		let copy=[50, 100, 150, 200, 250];
			this.setState({  
			  Bannerdata: resp.data,  
			   totaldata:parseInt(resp.data[0].count),rowsPaging:copy
			   

		    });
	  
	 
	 
     }
	 else{
		   this.setState({Bannerdata:[],totaldata:0});
	 }
 
    });
}





handleChangePage = (event, newPage) => {  

    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage);  });
   
 
    
  }; 
  
  handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
  

   
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); }); 
	
	
  }; 
  
  
  handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};


      BannerDelete(bnid){  
	
let r = window.confirm("Do you really want to Delete?");
 if(r == true){ //sign Out logic
 var formData = new FormData();
     formData.append('action','delete')
	 formData.append('bn_id',bnid)
	 	   
	formData.append('userid',localStorage.getItem("AYLuserid"))
	
	
	 axios.post(Serverurl+"ajaxbanner.php", formData, {
        }).then(res => {
    
              this.setState({  
      prevpage: -1,
    
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); });
  
    
            });
 }
      }
      BannnerAddbox(val){
        this.setState({bnid:val });  
  
         setTimeout(() => this.refs.Addbannerbox.handleClickOpen(),500);

      }

render() {

if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }


  return (
  
  
  



 
  <React.Fragment>
   

<div className="boxheading">				  
<h2>Manage Banners</h2>
</div>
<div className="clear"></div>
   <div className="searchmaster">


  
  <ul>
  
 <li>
 <p>Title</p>
 <p ><TextField
            variant="outlined"
            margin="normal"
            fullWidth value={this.state.bn_title}
           inputProps={{tabIndex: "1",maxLength:150}}
			placeholder="Name"
            name="bn_title" onChange={this.myChangeHandler} className="txtbox"
		
          /></p>
		 </li>
		
			
	<li><p>&nbsp;</p>
		 <p className="alignleft">Note:Image size: width=917px height=366px</p>
		</li>
	
		
		<li><p>
		<Button variant="contained" onClick={this.handleClickSearch} className="frmSecondarybtn" endIcon={<SearchIcon />}>
        Search
      </Button>&nbsp;
	  <Button variant="contained" onClick={()=>{this.BannnerAddbox(0)}} className="frmSecondarybtn" endIcon={<AddIcon />}>
        New
      </Button></p>
		</li> 
		
		
		
		
		</ul>
		
</div>		



<Addbannerbox ref="Addbannerbox" id={this.state.bnid}  updateDonenew={this.updateDonenewParent}/>
<Paper className={useStyles.root}>


  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.Bannerdata.length}
            />
                      <TableBody>
                     {stableSort(this.state.Bannerdata, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
           return (
 <React.Fragment>
 <TableRow key={index} >



<TableCell>{item.bn_title}</TableCell>
<TableCell>

	
			<div className="bannerimage"><img src={Serverurl+'uploads/'+item.bn_image} /></div>
	
		
</TableCell>

 

<TableCell align="left">
<div className="actionbtns">
<Button variant="contained" className="frmSecondarybtn" onClick={()=>{this.BannnerAddbox(item.bn_id)}} endIcon={<EditIcon />}>
Edit
</Button>&nbsp;&nbsp;


<Button variant="contained" className="frmthirdbtn" onClick={()=>{this.BannerDelete(item.bn_id)}} endIcon={<DeleteIcon />}>
  Delete
</Button>

 


 </div>
 
 </TableCell>
 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colspan="4">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
  <TablePagination  
        rowsPerPageOptions={[10,50, 100, 150, 200, 250]}  
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onChangePage={this.handleChangePage}  
        onChangeRowsPerPage={this.handleChangeRowsPerPage}  
      />   
  </Paper>
    

 </React.Fragment> 

 
 
  );
}
}


export  class  Addbannerbox extends Component {

   constructor(props) {
      super(props)
	  
      this.state = {
		  previocn:'',
		   open:false,name:'',bn_id:0,bn_title:'',bn_image:'',bn_sortorder:'',
      errormessage:'',erropen:false,btndisabled:'',bnid:'',
submitbtn:"Save"
	  }
      
  }
  
  
  

  
BannetGetData() {
	
  if(this.props.id!==0)
  {

	  
	   axios.get(Serverurl+'ajaxbanner.php?action=getall&bn_id='+this.props.id)
  .then(resp => {  
		
    if(resp.data.length>0){
    this.setState({ 
     
      bn_id:resp.data[0].bn_id,
	  bn_title: resp.data[0].bn_title,
      bn_sortorder: resp.data[0].bn_sortorder,
	  
	  previocn:resp.data[0].bn_image,
   
  
   


 
    });
	
  }
  
});
	  
  }else{
	 this.setState({  
	  bn_title:'',
	 previocn:'',
	 bn_image:'',
	 bn_title:'',
	 bn_id:0,
	  
	  }); 
 }
  
    }

   
handleClickOpen = (e) => {
 
  this.setState({open:!this.state.open,previocn:'',  bn_id:'',bn_title:'',bn_image:'',bn_sortorder:'',  
     errormessage:'',erropen:false,
	  });
		this.BannetGetData();
		


};
myChangeHandler = (event) => {
	
	  const re = /^[0-9\b]+$/;
  let nam = event.target.name;
  let val = event.target.value;  
    if(nam==="bn_sortorder")
  {
	  if (event.target.value === '' || re.test(event.target.value)) {
	  this.setState({[nam]: val}); 
	  
  }
  
  
  
 
  }
  else{
  this.setState({[nam]: val});
  }

}

 handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  }
   clickBannerclose=(event)=>{
	  
	this.setState({open: false});  
  }


handleClose = (e) => {
	
	const regst= /^[0-9]{2}[A-Z]{3}[ABCFGHLJPTF]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
 let bn_title = this.state.bn_title;
 let bn_sortorder = this.state.bn_sortorder;
 
 let bn_image = this.state.bn_image;
  let previocn = this.state.previocn;



if(bn_title==="")
{
	
	this.setState({errormessage:"Please Enter Title",erropen:true});
		
		 return false;
	
	
}

if(bn_sortorder==="")
{
	
	this.setState({errormessage:"Please Enter Sort Order",erropen:true});
		
		 return false;
	
	
}



if(previocn==="" && bn_image==="")
{
	
	this.setState({errormessage:"Please Upload Banner Image ",erropen:true});
		
		 return false;
	
	
}








 this.setState({btndisabled:true,submitbtn:"Processing..."})
   var formData = new FormData();
  
  
   if(this.state.bn_id==0)
	  {
		  formData.append('bn_id',0) 
		  
	  }
	  else
	  {
		  
	   formData.append('bn_id',this.state.bn_id)
		
          }
	  
	  
        formData.append('action','insertorupdate') 
		
		formData.append('bn_title',bn_title)
		formData.append('bn_sortorder',bn_sortorder)
		
	
	
	
	
	
				
	if(bn_image!=="")
	  {
		
		for (const key of Object.keys(this.state.bn_image)) {
            formData.append('Filedata', this.state.bn_image[key])
        }
 	
	   formData.append('bn_image','1')		
	  }else
	  {
		 formData.append('bn_image',this.state.previocn)	  
	  
	  }
	
	
		
		formData.append('userid',localStorage.getItem("AYLuserid"))
		  
		axios.post(Serverurl+"ajaxbanner.php", formData, {
        }).then(res => {
    
	
	
	if(res.data == -1)
{ 
	 

		this.setState({errormessage:"Name Already Exist.",erropen:true,open:true
		});
		window.scrollTo({
          top: 0
      })
		 return false;

	}
	
	
            this.props.updateDonenew();
    
        });
  
	
	this.setState({ open:false,btndisabled:false,
	 submitbtn:"Save", });
};

	 handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  } 

	



onFileChange=(e) =>{
	   	 
	   
	
	 let imageFile = e.target.files[0];
	 
	   this.setState({ bn_image: e.target.files })
	   
	   
	  
	   	
	
	  
  if (!imageFile.name.match(/\.(png|jpeg|jpg)$/)) {

  this.setState({errormessage:"Please Upload Valid banner (png,jpeg,jpg).",open:true});
		 window.scrollTo({        top: 0     })
	
  
    return false;
  }else{
        this.setState({ bn_image: e.target.files })
  }
  
		
    }




render (){

return(
<React.Fragment>





    <Dialog open={this.state.open} onClose={this.clickBannerclose} maxWidth="xs" fullWidth="true" aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">Manage Banner</DialogTitle>
      <DialogContent>
	  
<div className="formlist">

	<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity="error"
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
						  
						  
		
						  
	<p> <span className="validation">*</span> Title</p>
	
	<p><TextField name="bn_title" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.bn_title}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "1",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>	
		
	
	
	
	<p> <span className="validation">*</span>Sort Order</p>
	
	<p><TextField name="bn_sortorder" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.bn_sortorder}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "1",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>	
	
	
		<p>  <div className="uploadbtn">	  
		  

	<Button component="label"  className="iconuploadbtn" name="bn_image"  onChange={this.onFileChange}   variant="contained"   accept="image/*;capture=camera" startIcon={<CloudUploadIcon />}>
	
		Uplaod Image
		<VisuallyHiddenInput type="file"   /></Button>
		
		{this.state.previocn!=="" &&(
			<p><img src={Serverurl+'uploads/'+this.state.previocn} target='_blank' style={{'width':'90px'}}/></p>
	
			)}

	</div></p>
		   
		   
		   
		 
		
		
		
		
       <div className="actionbtns">
	   <div className="cancelbtn">
	   <Button variant="contained" className="frmthirdbtn" onClick={this.clickBannerclose}>
Cancel
</Button>
</div> 
<div className="savebtn">
<Button variant="contained" className="frmSecondarybtn" onClick={this.handleClose}>
    {this.state.submitbtn}
</Button>
    </div>        


	
<div className="clear"></div>

 </div>     
	</div>		 
						    </DialogContent>
      
    </Dialog>
</React.Fragment>

) }
 
}